<template>
  <v-container fluid @click="restNotifications()">
    <div class="d-block d-md-flex">
      <AppAside></AppAside>
      <div class="ps-5 page_content grow">
        <v-skeleton-loader v-if="!data_loaded" type="table"></v-skeleton-loader>
        <v-card v-if="data_loaded">
          <v-card-title class="align-center">
            <div class="d-flex align-center">
              <v-icon x-large>local_mall</v-icon>
              <h1 class="ms-3">הזמנות</h1>
            </div>
            <v-spacer></v-spacer>
            <div class="d-flex align-center">
              <v-btn @click="excelProp = true" text fab small>
                <img src="@/assets/excel.png" alt="" />
              </v-btn>
              <v-text-field
                outlined
                dense
                hide-details
                label="מספר הזמנה"
                v-model="search_key"
                class="mx-3"
              ></v-text-field>
              <v-btn outlined color="primary" @click="search_order()"
                >חיפוש</v-btn
              >
            </div>
          </v-card-title>
          <v-data-table
            class="order_table"
            :mobile-breakpoint="0"
            :hide-default-footer="true"
            :disable-pagination="true"
            :items="items"
            :headers="headers"
          >
            <template v-slot:[`item.ready_time`]="{ item }">
              <v-chip x-small color="black white--text">
                {{
                  `${item.ready_time} ${item.ready_time > 1 ? "דקות" : "דקה"}`
                }}
              </v-chip>
            </template>
            <template v-slot:[`item.preparedBy`]="{ item }">
              <span v-if="item.preparedBy">
                <v-chip
                  x-small
                  color="orange white--text"
                  v-if="item.preparedBy.is_admin"
                >
                  {{ item.preparedBy.name }}
                </v-chip>
                <span v-else>
                  {{ item.preparedBy.name }}
                </span>
              </span>
              <span v-else> __ </span>
            </template>
            <template v-slot:[`item.customer`]="{ item }">
              <v-chip
                small
                :color="item.is_special ? '#ffd700' : 'transparent'"
              >
                {{
                  item.customer.name.length >= 15
                    ? item.customer.name.slice(0, 15) + "..."
                    : item.customer.name
                }}
              </v-chip>
            </template>

            <template v-slot:[`item.address`]="{ item }">
              <v-chip
                x-small
                class="px-2"
                :color="item.address ? 'green' : 'red white--text'"
              >
                {{ item.address ? "כן" : "לא" }}
              </v-chip>
            </template>

            <template v-slot:[`item.delivery_method`]="{ item }">
              <v-chip
                small
                label
                class="px-2 black--text"
                :color="item.delivery_method ? '' : 'warning'"
              >
                <v-icon>
                  {{ item.delivery_method ? "handshake" : "house" }}
                </v-icon>
              </v-chip>
            </template>

            <template v-slot:item.payment_method="{ item }">
              {{ item.payment_method == "visa" ? "אשראי" : "מזומן" }}
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <v-btn
                class="me-2"
                v-if="item.status == 'preparation'"
                depressed
                x-small
                fab
                color="grey white--text"
                @click="show_order(item)"
              >
                <v-icon x-small>visibility</v-icon>
              </v-btn>

              <v-btn
                color="primary elevation-0 me-2"
                fab
                x-small
                :disabled="update_status_prop"
                :loading="update_status_prop"
                v-if="
                  item.status != 'canceled' &&
                  item.status != 'done' &&
                  item.status != 'preparation' &&
                  $store.getters.permission('orders edit')
                "
                @click="update_status(item)"
              >
                <v-icon>rv_hookup</v-icon>
              </v-btn>

              <v-chip
                class="px-2"
                x-small
                color="warning"
                v-if="item.status == 'pending'"
              >
                בהמתנה
              </v-chip>
              <v-chip
                class="px-2"
                x-small
                color="grey lighten-2"
                v-if="item.status == 'new'"
              >
                חדש
              </v-chip>
              <v-chip
                class="px-2"
                x-small
                color="warning darken-1"
                v-else-if="item.status == 'preparation'"
              >
                בהכנה
              </v-chip>

              <v-chip
                class="px-2"
                x-small
                color="pink success"
                v-else-if="item.status == 'ready'"
              >
                מוכן
              </v-chip>

              <v-chip
                class="px-2"
                x-small
                color="blue lighten-2 white--text"
                v-else-if="item.status == 'in_progress_delivery'"
              >
                בדרך
              </v-chip>
              <v-chip
                class="px-2"
                x-small
                color="priamry lighten-2"
                v-else-if="item.status == 'delivery_arrived'"
              >
                הגיע השליח
              </v-chip>

              <v-chip
                class="px-2"
                x-small
                color="green darken-1 white--text"
                v-else-if="item.status == 'done'"
              >
                טופל
              </v-chip>

              <v-chip
                class="px-2"
                x-small
                color="red lighten-2 white--text"
                v-else-if="item.status == 'canceled'"
              >
                מבוטלת
              </v-chip>
            </template>
            <template v-slot:[`item.delivery`]="{ item }">
              <span>
                <v-btn
                  v-if="
                    $store.getters.permission('orders edit') &&
                    item.status != 'done' &&
                    item.status != 'canceled' &&
                    item.delivery_method != 1
                  "
                  @click="select_delivery(item)"
                  :color="item.delivery ? 'grey lighten-2' : 'primary'"
                  x-small
                  rounded
                  color="grey lighten-3"
                  depressed
                >
                  <v-chip
                    style="cursor: pointer"
                    x-small
                    color="primary"
                    class="me-2"
                  >
                    {{ item.delivery ? item.delivery.name : "הוספת" }}
                  </v-chip>
                  <v-chip
                    style="cursor: pointer"
                    x-small
                    v-if="item.sub_delivery"
                  >
                    {{ item.sub_delivery.name }}
                  </v-chip>
                  <v-icon small color="success darken-2">add</v-icon>
                </v-btn>
                <span v-else>
                  <span class="me-2">
                    {{ item.delivery ? item.delivery.name : "__" }}
                  </span>
                  <span v-if="item.sub_delivery"> - </span>
                  <span v-if="item.sub_delivery">
                    {{ item.sub_delivery.name }}
                  </span>
                </span>
              </span>
            </template>

            <template v-slot:[`item.delivery_cost`]="{ item }">
              ₪{{ item.delivery_cost }}
            </template>
            <template v-slot:[`item.brand_campaign_discount`]="{ item }">
              <span v-if="item.brand_campaign_discount">
                - ₪{{ item.brand_campaign_discount }}
              </span>
              <span v-else>₪0</span>
            </template>
            <template v-slot:[`item.gift`]="{ item }">
              <span v-if="item.gift_campaign">
                <v-btn
                  x-small
                  color="green white--text"
                  @click="openGiftDialog(item.gift_campaign)"
                >
                  {{ item.gift_campaign.gift_name }}
                </v-btn>
              </span>
              <span v-else>__</span>
            </template>
            <template v-slot:[`item.coupon`]="{ item }">
              ₪{{ couponCost(item) }}
            </template>
            <template v-slot:[`item.total_products`]="{ item }">
              ₪{{ item.total }}
            </template>
            <template v-slot:[`item.total`]="{ item }">
              ₪{{ totalOrder(item) }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                small
                icon
                :loading="invoiceLoadingId === item.id"
                :disabled="invoiceLoadingId === item.id"
                :color="item.invoice ? 'primary' : 'grey darken-1'"
                @click="openInvoiceDialog(item)"
                title="חשבונית"
              >
                <v-icon small>receipt_long</v-icon>
              </v-btn>

              <v-btn
                v-if="
                  item.address &&
                  item.address.longitude &&
                  item.address.latitude
                "
                target="_blank"
                :href="`https://waze.com/ul?ll=${item.address.longitude},${item.address.latitude}`"
                small
                icon
              >
                <img src="@/assets/waze.png" width="15" />
              </v-btn>

              <v-btn
                v-if="item.address"
                target="_blank"
                :href="`https://www.google.com/maps?q=${item.address.latitude},${item.address.longitude}`"
                small
                icon
              >
                <v-icon small> location_on </v-icon>
              </v-btn>
              <v-btn icon small @click="show_order(item)">
                <v-icon small>visibility</v-icon>
              </v-btn>

              <v-btn
                v-if="
                  item.delivery && item.delivery_method == 0 && item.address
                "
                small
                icon
                :loading="item.whatsappLoading"
                @click="openWhatsapp(item)"
              >
                <img src="@/assets/whatsapp.png" width="15" />
              </v-btn>

              <v-btn
                v-if="item.status != 'done' && item.status != 'canceled'"
                small
                icon
                @click="cancele_order(item)"
              >
                <v-icon color="red">close</v-icon>
              </v-btn>

              <v-btn x-small icon @click="printCoupon(item)">
                <v-icon>print</v-icon>
              </v-btn>

              <v-btn
                x-small
                icon
                title="מספר שקיות"
                @click="openBagsDialog(item)"
              >
                <v-icon>local_mall</v-icon>
              </v-btn>
            </template>
            <!--/ actions -->
          </v-data-table>
        </v-card>
        <template>
          <div
            style="margin-bottom: 100px"
            v-if="data_loaded"
            class="text-center mt-4 d-flex justify-center"
          >
            <v-pagination
              @input="get_data()"
              v-model="page"
              total-visible="7"
              :length="total"
              circle
            ></v-pagination>
          </div>
        </template>

        <DownloadExcel
          :excelProp="excelProp"
          @closeDownloadExcel="excelProp = false"
        />
        <SelectDelivery
          @close_select_delivery="select_delivery_prop = false"
          @update_data="get_data(), (select_delivery_prop = false)"
          v-if="select_delivery_prop"
          :select_delivery_prop="select_delivery_prop"
          :order="order"
        />
        <ShowOrder
          :loading_update_status="loading_update_status"
          @update_status="update_status($event)"
          @walletInput="($event) => (order.addedWallet = $event)"
          :casherDiscount="casherDiscount"
          @close_show_order="(ShowOrderDialog = false), (order = null)"
          v-if="order"
          :ShowOrderDialog="ShowOrderDialog"
          :order="order"
        />
      </div>
    </div>

    <DeleteDialog
      :approve="`כן`"
      :cancel="`לא`"
      @delete_done="get_data()"
      @close_delete="delete_obj.delete_prop = false"
      :delete_obj="delete_obj"
    ></DeleteDialog>

    <!-- Gift Details Dialog -->
    <v-dialog v-model="giftDialog" max-width="500">
      <v-card v-if="selectedGift">
        <v-card-title class="headline">פרטי מתנה</v-card-title>
        <v-card-text>
          <v-list dense>
            <v-list-item>
              <v-list-item-content>
                <div class="d-flex justify-space-between">
                  <span class="font-weight-bold">שם המתנה:</span>
                  <span>{{ selectedGift.gift_name }}</span>
                </div>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <div class="d-flex justify-space-between">
                  <span class="font-weight-bold">סוג:</span>
                  <span>{{ selectedGift.type == 'brand' ? 'מותג' : 'סה"כ סל' }}</span>
                </div>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="selectedGift.value_to_get_gift">
              <v-list-item-content>
                <div class="d-flex justify-space-between">
                  <span class="font-weight-bold">שווי לקבלת מתנה:</span>
                  <span>₪{{ selectedGift.value_to_get_gift }}</span>
                </div>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="selectedGift.gift_image">
              <v-list-item-content class="text-center mt-3">
                <img
                  :src="`${$store.state.def_path}/${selectedGift.gift_image}`"
                  style="max-width: 100%; max-height: 250px; object-fit: contain; border-radius: 8px;"
                />
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="giftDialog = false">סגור</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Invoice Dialog -->
    <v-dialog v-model="invoiceDialog" max-width="480">
      <v-card v-if="selectedInvoiceOrder">
        <v-card-title class="headline d-flex align-center">
          <v-icon class="me-2" color="primary">receipt_long</v-icon>
          <span>חשבונית להזמנה #{{ selectedInvoiceOrder.order_num }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <div class="mb-2" v-if="selectedInvoiceOrder.customer">
            <strong>לקוח: </strong> {{ selectedInvoiceOrder.customer.name }} ({{ selectedInvoiceOrder.customer.phone }})
          </div>
          <div class="mb-4">
            <strong>סכום: </strong> ₪{{ totalOrder(selectedInvoiceOrder) }}
          </div>
          <div class="d-flex flex-column">
            <v-btn
              color="primary"
              depressed
              class="mb-3 white--text"
              target="_blank"
              :href="getInvoiceUrl(selectedInvoiceOrder)"
            >
              <v-icon left small>visibility</v-icon>
              צפייה בחשבונית
            </v-btn>

            <v-btn
              color="grey lighten-2"
              depressed
              class="mb-3 black--text"
              @click="downloadInvoice(selectedInvoiceOrder)"
            >
              <v-icon left small>file_download</v-icon>
              הורדת חשבונית
            </v-btn>

            <v-btn
              outlined
              color="primary"
              class="mb-2"
              @click="copyInvoiceUrl(selectedInvoiceOrder)"
            >
              <v-icon left small>content_copy</v-icon>
              העתקת קישור לחשבונית
            </v-btn>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="invoiceDialog = false">סגור</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Bags Stickers Dialog -->
    <v-dialog v-model="bagsDialog" max-width="420" persistent>
      <v-card v-if="selectedBagsOrder">
        <v-card-title class="headline d-flex align-center">
          <v-icon class="me-2" color="primary">local_mall</v-icon>
          <span>מספר שקיות</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <div class="d-flex align-center">
            <v-text-field
              v-model.number="bagsCount"
              type="number"
              min="1"
              step="1"
              dense
              outlined
              hide-details
              label="מספר שקיות"
              @blur="normalizeBagsCount"
            ></v-text-field>
            <v-btn
              color="primary"
              fab
              small
              class="ms-3"
              title="הוספה"
              @click="increaseBags()"
            >
              <v-icon>add</v-icon>
            </v-btn>
          </div>

          <div class="d-flex mt-4">
            <v-btn
              class="grow"
              large
              :color="bagOption === 'A' ? 'primary' : 'grey lighten-3'"
              :class="bagOption === 'A' ? 'white--text' : 'black--text'"
              @click="bagOption = 'A'"
            >
              A
            </v-btn>
            <v-btn
              class="grow ms-2"
              large
              :color="bagOption === 'B' ? 'primary' : 'grey lighten-3'"
              :class="bagOption === 'B' ? 'white--text' : 'black--text'"
              @click="bagOption = 'B'"
            >
              B
            </v-btn>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="primary"
            depressed
            class="white--text"
            @click="printBagsStickers()"
          >
            <v-icon left small>print</v-icon>
            הדפסה
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="grey lighten-2"
            depressed
            class="black--text"
            @click="bagsDialog = false"
          >
            סגירה
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="invoiceSnackbar" :color="invoiceSnackbarColor" bottom left>
      {{ invoiceSnackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="invoiceSnackbar = false">
          <v-icon small>close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import SelectDelivery from "@/components/orders/SelectDelivery";
import ShowOrder from "@/components/orders/ShowOrder";
import DownloadExcel from "@/components/orders/DownloadExcel";
import DeleteDialog from "@/components/public/delete";
export default {
  name: "orders",
  data() {
    return {
      loading_update_status: false,
      search_key: "",
      update_status_prop: false,
      select_delivery_prop: false,
      page: 1,
      data_loaded: false,
      items: [],
      total: 0,
      order: null,
      delete_obj: {
        delete_prop: false,
        delete_url: "cancel_order",
        title: "ביטול הזמנה ؟ ",
        id: null,
      },

      ShowOrderDialog: false,
      order: null,
      excelProp: false,
      giftDialog: false,
      selectedGift: null,
      invoiceDialog: false,
      selectedInvoiceOrder: null,
      invoiceLoadingId: null,
      invoiceSnackbar: false,
      invoiceSnackbarText: "",
      invoiceSnackbarColor: "success",
      bagsDialog: false,
      selectedBagsOrder: null,
      bagsCount: 1,
      bagOption: "A",
    };
  },
  components: {
    SelectDelivery,
    ShowOrder,
    DeleteDialog,
    DownloadExcel,
  },

  computed: {
    headers() {
      const headers = [
        {
          value: "daily_number",
          text: "מספר יומי",
          align: "center",
        },
        {
          value: "created_at",
          text: "תאריך",
          align: "center",
        },
        {
          value: "ready_time",
          text: "זמן מוכן",
          align: "center",
          has_permission: true,
          permission: this.$store.getters.permission("orders logs access"),
        },
        {
          value: "preparedBy",
          text: "מוכן על ידי",
          align: "center",
          has_permission: true,
          permission: this.$store.getters.permission("orders logs access"),
        },
        {
          value: "order_num",
          text: "מספר הזמנה",
          align: "center",
        },
        {
          value: "address",
          text: "כתובת",
          align: "center",
        },
        {
          value: "delivery_method",
          text: "delivery_method",
          align: "center",
        },
        {
          value: "status",
          text: "סטטוס",
          align: "center",
        },
        {
          value: "payment_method",
          text: "סוג תשלום",
          align: "center",
        },
        {
          value: "customer",
          text: "לקוח",
          align: "center",
        },
        {
          value: "delivery",
          text: "שליח",
          align: "center",
        },
        {
          value: "delivery_cost",
          text: "עלות משלוח",
          align: "center",
        },
        {
          value: "brand_campaign_discount",
          text: "הנחת קמפיין",
          align: "center",
        },
        {
          value: "coupon",
          text: "coupon",
          align: "center",
          has_permission: true,
          permission: this.$store.getters.permission("coupons access"),
        },
        {
          value: "gift",
          text: "מתנה",
          align: "center",
        },
        {
          value: "walletDiscount",
          text: "walletDiscount",
          align: "center",
          has_permission: true,
          permission: this.$store.getters.permission("customer_wallet"),
        },
        {
          value: "total_products",
          text: "סה”כ",
          align: "center",
        },
        {
          value: "total",
          text: "סה”כ",
          align: "center",
        },
        {
          value: "actions",
          text: "פעולות",
          align: "center",
        },
      ];

      return headers.filter(
        (e) => !e.has_permission || (e.has_permission && e.permission),
      );
    },
    couponCost: (app) => (order) => {
      if (order.coupon) {
        return order.total <= order.coupon.discount
          ? order.total
          : order.coupon.discount;
      }
      return 0;
    },
    casherDiscount() {
      if (!this.order || (this.order && this.order.addedWallet <= 0)) {
        return 0;
      } else {
        return this.order ? this.order.total - this.order.addedWallet : 0;
      }
    },
    whatsapp_msg: (app) => (order, driverUrl = null) => {
      const dailyPart =
        order.daily_number != null && order.daily_number !== ""
          ? ` (${order.daily_number})`
          : "";
      let msg = `הזמנה חדשה מס : ${order.order_num}${dailyPart} %0a
      לקוח: ${order.customer ? order.customer.name : ''}%0a
      מספר לקוח: ${order.customer ? order.customer.phone : ''}%0a
      איזור :  ${order.address ? order.address.place : ''}%0a
      סה”כ משלוח :   ${order.delivery_cost}%0a
      סה”כ הזמנה :  ${order.total}%0a
      סה״כ לתשלום:  ${
        order.total - app.couponCost(order) + order.delivery_cost
      }%0a
      הערה לכתובת :  ${order.address ? order.address.address : ''}    %0a`;

      const url = driverUrl || order.driver_summary_url;
      if (url) {
        msg += `קישור לפרטי הזמנה וחשבונית: %0a${url}%0a`;
      }
      return msg;
    },
  },
  watch: {
    "$store.getters.notifications"() {
      this.get_data();
    },
  },
  methods: {
    get_data() {
      this.$store
        .dispatch("public__request", {
          config: {
            url: `orders${this.search_key ? "/" + this.search_key : ""}?page=${
              this.page
            }`,
            method: "get",
          },
        })
        .then((res) => {
          const apiResponse = res && res.data;
          console.log(apiResponse);
          if (!apiResponse || !apiResponse.data) {
            this.data_loaded = true;
            return;
          }
          const payload = apiResponse.data; 

          this.items = Object.assign([], payload.data || []);
          this.total = (payload.meta && payload.meta.last_page) || 0;
          this.page = (payload.meta && payload.meta.current_page) || 1;
          this.data_loaded = true;
        });
    },
    search_order() {
      this.page = 1;
      this.get_data();
    },
    select_delivery(order) {
      this.order = Object.assign({}, order);
      this.select_delivery_prop = true;
    },
    show_order(order) {
      order.products
        .sort((a, b) => {
          const numeric = /^[-+]??\d+/;

          const isNumericA = numeric.test(a.sku);
          const isNumericB = numeric.test(b.sku);
          // e.g. compare 5 and 6
          if (isNumericA && isNumericB) {
            return parseInt(a.sku, 10) - parseInt(b.sku, 10);
          }

          // e.g. 5 and A2
          if (isNumericA && !isNumericB) {
            return -1;
          }

          // e.g. A2 and 6
          if (!isNumericA && isNumericB) {
            return 1;
          }

          const alphabets = /^[a-zA-Z]+/;
          // Alphabet + number: A1, B3...
          const aAlphabets = a.sku.replace(/\d+/g, "");
          const bAlphabets = b.sku.replace(/\d+/g, "");
          if (aAlphabets === bAlphabets) {
            // e.g. Compare AB10 and AB12
            const aNumber = a.sku.replace(alphabets, "");
            const bNumber = b.sku.replace(alphabets, "");
            // e.g. Compare 10 and 12 for AB10 and AB12
            const result =
              aNumber === bNumber
                ? 0
                : parseInt(aNumber, 10) - parseInt(bNumber, 10);
            console.log(`A: ${a.sku}, B: ${b.sku}, result: ${result}`);
            return result;
          }
          // e.g. A12 and B12
          return aAlphabets > bAlphabets ? 1 : -1;
        })
        .join(",");

      this.order = order;

      this.$nextTick(() => {
        this.ShowOrderDialog = true;
      });
    },
    update_status(order) {
      if (
        !this.update_status_prop &&
        this.$store.getters.permission("orders edit")
      ) {
        //  this.update_status_prop = true;
        this.loading_update_status = true;

        console.log(order.id);
        this.$store
          .dispatch("public__request", {
            config: {
              url: `status/${order.id}`,
              method: "put",
            },
            data: {
              walletAmount: order.addedWallet,
            },
          })
          .then((res) => {
            order.status = res.data.data.status;

            if (res.data.data.status == "done") {
              this.$store.dispatch("active_orders");
            }
            this.$nextTick(() => {
              this.update_status_prop = false;
            });
            this.loading_update_status = false;
          });
      }
    },
    cancele_order(order) {
      this.delete_obj.id = order.id;
      this.delete_obj.delete_prop = true;
    },

    totalOrder(order) {
      let final = 0;
      if (order.coupon) {
        final =
          order.total - order.coupon.discount < 0
            ? 0
            : order.total - order.coupon.discount;
        final += order.delivery_cost;
      } else {
        final = order.total - order.walletDiscount + order.delivery_cost;
      }
      if (order.brand_campaign_discount) {
        final -= order.brand_campaign_discount;
      }
      return final < 0 ? 0 : final;
    },
    openGiftDialog(gift) {
      this.selectedGift = gift;
      this.giftDialog = true;
    },
    restNotifications() {
      this.$store.commit("resetNotifications");
    },
    printCoupon(order) {
      const printWindow = window.open("", "_blank", "width=800,height=600");

      const orderDate = new Date(order.new_time || order.created_at);
      const formattedDate = orderDate.toLocaleDateString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });

      const couponContent = `
        <!DOCTYPE html>
        <html dir="rtl" lang="ar">
        <head>
          <meta charset="UTF-8">
          <title>كوبون الطلب</title>
          <style>
            @page {
              size: 10cm 10cm;
              margin: 0;
            }
            
            @media print {
              body { 
                margin: 0; 
                width: 10cm;
                height: 10cm;
              }
              .coupon { 
                width: 10cm; 
                height: 10cm; 
                margin: 0;
                padding: 15px;
                box-sizing: border-box;
              }
            }
            
            body {
              font-family: 'Arial', sans-serif;
              margin: 0;
              direction: rtl;
              width: 10cm;
              height: 10cm;
              overflow: hidden;
            }
            
            .coupon {
              width: 10cm;
              height: 10cm;
              border: 3px solid #000;
              border-radius: 10px;
              padding: 15px;
              text-align: center;
              background: #fff;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              margin: 0;
            }
            
            .coupon-header {
              font-size: 20px;
              font-weight: bold;
              margin-bottom: 15px;
              color: #000;
              border-bottom: 2px solid #000;
              padding-bottom: 8px;
              width: 100%;
            }
            
            .coupon-info {
              font-size: 16px;
              font-weight: bold;
              margin: 10px 0;
              color: #000;
            }
            
            .coupon-value {
              font-size: 18px;
              font-weight: bold;
              color: #000;
              margin-bottom: 15px;
              padding: 8px;
              background: #f5f5f5;
              border-radius: 5px;
              min-width: 180px;
            }
            
            .order-number {
              font-size: 24px;
              font-weight: bold;
              color: #000;
              margin-bottom: 20px;
              padding: 10px;
              background: #f0f0f0;
              border-radius: 8px;
              min-width: 200px;
              border: 2px solid #000;
            }
            
            .coupon-footer {
              font-size: 12px;
              font-weight: bold;
              margin-top: 15px;
              color: #666;
              border-top: 1px solid #ccc;
              padding-top: 8px;
              width: 100%;
            }
              #barcode {
                width: 100%;
                height: 70px;
              }
          </style>


        </head>
        <body>
          <div class="coupon">
            <div class="coupon-info">
              <svg id="barcode"></svg>
              <div class="coupon-value">${
                order.customer ? order.customer.name : "غير محدد"
              }</div>
              
              <div class="coupon-value">${
                order.customer ? order.customer.phone : "غير محدد"
              }</div>
              
              <div class="coupon-value">${formattedDate}</div>
            </div>
            
            <div class="coupon-footer">شكراً لاختيارك تطبيقنا :)</div>
          </div>

        </body>
        </html>
      `;

      printWindow.document.write(couponContent);
      printWindow.document.close();

      printWindow.onload = function () {
        const script = printWindow.document.createElement("script");
        script.src =
          "https://cdn.jsdelivr.net/npm/jsbarcode@3.11.6/dist/JsBarcode.all.min.js";
        script.onload = function () {
          const svg = printWindow.document.getElementById("barcode");
          console.log(svg);

          printWindow.JsBarcode(svg, order.order_num || order.id, {
            format: "CODE128",
            lineColor: "#000",
            width: 2,
            height: 50,
            displayValue: true,
          });

          printWindow.print();
          printWindow.close();
        };
        printWindow.document.head.appendChild(script);
      };
    },
    getInvoiceUrl(order) {
      if (!order || !order.invoice) return "";
      return `${this.$store.state.def_path}/${order.invoice}`;
    },
    openBagsDialog(order) {
      this.selectedBagsOrder = order;
      this.bagsCount = 1;
      this.bagOption = "A";
      this.bagsDialog = true;
    },
    normalizeBagsCount() {
      const parsed = parseInt(this.bagsCount, 10);
      this.bagsCount = !parsed || parsed < 1 ? 1 : parsed;
    },
    increaseBags() {
      this.normalizeBagsCount();
      this.bagsCount += 1;
    },
    escapeHtml(value) {
      return String(value === null || value === undefined ? "" : value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    },
    printBagsStickers() {
      const order = this.selectedBagsOrder;
      if (!order) return;

      this.normalizeBagsCount();
      const count = this.bagsCount;
      const option = this.bagOption;
      const dailyNumber = this.escapeHtml(order.daily_number);
      const orderNum = this.escapeHtml(order.order_num || order.id);

      const today = new Date();
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const yyyy = today.getFullYear();
      const todayDate = `${dd}/${mm}/${yyyy}`;

      let stickers = "";
      for (let i = 1; i <= count; i++) {
        stickers += `
          <div class="sticker">
            <div class="option">${option}</div>
            <div class="daily">${dailyNumber}</div>
            <div class="order-num">${orderNum}</div>
            <div class="bag-num">${i}/${count}</div>
            <div class="today-date">${this.escapeHtml(todayDate)}</div>
          </div>
        `;
      }

      const stickerContent = `
        <!DOCTYPE html>
        <html dir="rtl" lang="he">
        <head>
          <meta charset="UTF-8">
          <title>שקיות</title>
          <style>
            @page {
              size: 10cm 10cm;
              margin: 0;
            }

            html, body {
              margin: 0;
              padding: 0;
              background: #fff;
            }

            .sticker {
              width: 10cm;
              height: 10cm;
              box-sizing: border-box;
              padding: 0.4cm;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              text-align: center;
              overflow: hidden;
              font-family: 'Arial', sans-serif;
              color: #000;
              page-break-after: always;
              break-after: page;
            }

            .sticker:last-child {
              page-break-after: auto;
              break-after: auto;
            }

            .option {
              font-size: 2.8cm;
              font-weight: 900;
              line-height: 1;
            }

            .daily {
              font-size: 2cm;
              font-weight: 900;
              line-height: 1.1;
            }

            .order-num {
              font-size: 0.6cm;
              font-weight: bold;
              line-height: 1.2;
            }

            .bag-num {
              font-size: 1.2cm;
              font-weight: 900;
              margin-top: 0.3cm;
            }

            .today-date {
              font-size: 0.35cm;
              font-weight: 600;
              line-height: 1.2;
              margin-top: 0.25cm;
              letter-spacing: 0.5px;
            }
          </style>
        </head>
        <body>
          ${stickers}
        </body>
        </html>
      `;

      const printWindow = window.open("", "_blank", "width=800,height=600");
      printWindow.document.write(stickerContent);
      printWindow.document.close();

      let printed = false;
      const doPrint = function () {
        if (printed) return;
        printed = true;
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      };
      printWindow.onload = doPrint;
      setTimeout(doPrint, 500);
    },
    openInvoiceDialog(item) {
      if (item.invoice) {
        this.selectedInvoiceOrder = item;
        this.invoiceDialog = true;
        return;
      }

      this.invoiceLoadingId = item.id;
      this.$store
        .dispatch("public__request", {
          config: {
            url: `orders/${item.id}/create-invoice`,
            method: "POST",
          },
        })
        .then((res) => {
          this.invoiceLoadingId = null;
          if (res.data && res.data.data && res.data.data.invoice) {
            item.invoice = res.data.data.invoice;
            this.selectedInvoiceOrder = item;
            this.invoiceDialog = true;
            this.showInvoiceSnackbar("החשבונית נוצרה בהצלחה", "success");
          } else {
            this.showInvoiceSnackbar("שגיאה ביצירת החשבונית", "error");
          }
        })
        .catch((err) => {
          this.invoiceLoadingId = null;
          const msg =
            err.response && err.response.data && err.response.data.message
              ? err.response.data.message
              : "שגיאה ביצירת החשבונית";
          this.showInvoiceSnackbar(msg, "error");
        });
    },
    downloadInvoice(order) {
      const url = this.getInvoiceUrl(order);
      if (!url) return;

      const filename = `invoice-${order.order_num || order.id}.pdf`;
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    copyInvoiceUrl(order) {
      const url = this.getInvoiceUrl(order);
      if (!url) return;

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(url)
          .then(() => {
            this.showInvoiceSnackbar("הקישור הועתק בהצלחה", "success");
          })
          .catch(() => {
            this.fallbackCopy(url);
          });
      } else {
        this.fallbackCopy(url);
      }
    },
    fallbackCopy(text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.opacity = "0";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand("copy");
        this.showInvoiceSnackbar("הקישור הועתק בהצלחה", "success");
      } catch (err) {
        this.showInvoiceSnackbar("לא ניתן להעתיק את הקישור", "error");
      }
      document.body.removeChild(textArea);
    },
    showInvoiceSnackbar(text, color = "success") {
      this.invoiceSnackbarText = text;
      this.invoiceSnackbarColor = color;
      this.invoiceSnackbar = true;
    },
    async openWhatsapp(item) {
      if (item.whatsappLoading) return;
      this.$set(item, "whatsappLoading", true);

      // Open a blank window early to avoid mobile popup blockers after async await
      const waWin = window.open("about:blank", "_blank");

      try {
        let driverUrl = item.driver_summary_url;
        if (!driverUrl) {
          const res = await this.$store.dispatch("public__request", {
            config: {
              url: `orders/${item.id}/driver-link`,
              method: "GET",
            },
          });
          if (res && res.data && res.data.data) {
            driverUrl = res.data.data.driver_summary_url;
            this.$set(item, "driver_summary_url", driverUrl);
          }
        }

        const text = this.whatsapp_msg(item, driverUrl);
        const phone = ((item.delivery && item.delivery.phone) || "").replace(/[^0-9]/g, "");
        const targetUrl = `https://wa.me/${phone}?text=${text}`;

        if (waWin) {
          waWin.location.href = targetUrl;
        } else {
          window.location.href = targetUrl;
        }
      } catch (err) {
        console.error(err);
        const text = this.whatsapp_msg(item);
        const phone = ((item.delivery && item.delivery.phone) || "").replace(/[^0-9]/g, "");
        const targetUrl = `https://wa.me/${phone}?text=${text}`;
        if (waWin) {
          waWin.location.href = targetUrl;
        } else {
          window.location.href = targetUrl;
        }
      } finally {
        this.$set(item, "whatsappLoading", false);
      }
    },
  },
  mounted() {
    this.get_data();
  },
};
</script>

<style lang="scss">
.order_table {
  td:nth-of-type(3),
  td:nth-of-type(4),
  td:nth-of-type(9),
  td:nth-of-type(10),
  td:nth-of-type(11),
  td:nth-of-type(12) {
    width: 40px;
  }
}
</style>
